function fixedBalance(balance, decimals) {
  balance = typeof balance === "number" ? balance : Number(balance);
  decimals = typeof decimals === "number" ? decimals : Number(decimals);
  return balance / Math.pow(10, decimals);
}
export {
  fixedBalance
};
//# sourceMappingURL=balance.js.map
